export const STATUS_TAG_DICTIONARY = {
  'Appointment Today': 'blue',
  'Active Campaign': 'blue',
  'Automation Running': 'blue',
  'RO in Progress': 'blue',
  'Waiting Response': 'orange',
  'Customer Replied': 'orange',
  'Needs Approval': 'orange',
  'Follow-Up Needed': 'orange',
  'Confirm Appointment': 'orange',
  'Unassigned Lead': 'orange',
  'RO Stalled': 'orange',
  'Escalated': 'red',
  'Callback Overdue': 'red',
  'Workflow Failed': 'red',
  'SLA Breached': 'red',
};
